import {BootstrapButton, BootstrapModal} from '../react-bootstrap'
import {bindState, pick, renderErrors, scrollToErrors} from '../utils';

/* eslint globals: ["countries"] */

export class EditAddressForm extends React.Component {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);

        this.bindState = bindState;

        this.state = {
            address: props.address,
        };
    }

    componentWillUnmount () {
        this.xhr && this.xhr.abort();
    }

    onSubmit(e) {
        e.preventDefault();
        var data = this.state.address;
        $.postJSON('/user_addresses/' + data.id + '/edit', data).done(data => {
            location.href = '/users/profile#my-addresses';
        }).fail((xhr, textStatus, errorThrown) => {
            if (xhr.status === 400) {
                this.setState({errors: {address: xhr.responseJSON.errors}}, scrollToErrors);
            } else if (xhr.status === 401) {
                this.setState({errors: {_overall_: ['You have not logged in. Please log in again.']}}, this.scrollToErrors);
            } else {
                this.setState({errors: {_overall_: ['Operation failed.']}}, this.scrollToErrors)
            }
        }).always((xhr, textStatus, errorThrown) => {
            this.xhr = null
        });
    }

    renderAddressErrors(address_field, field) {
        return renderErrors(this.state.errors && this.state.errors[address_field] && this.state.errors[address_field][field]);
    }

    renderAddressFields() {
        var address_field = 'address';
        var country = this.state[address_field].country;
        return (
            <div className={address_field + "-container"}>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-first_name"} className="control-label">First Name</label>
                            <input id={address_field + "-first_name"} type="text" className="form-control" placeholder="First Name" value={this.state[address_field].first_name} onChange={this.bindState(address_field + '.first_name')} />
                            {this.renderAddressErrors(address_field, 'first_name')}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-last_name"} className="control-label">Last Name</label>
                            <input id={address_field + "-last_name"} type="text" className="form-control" placeholder="Last Name" value={this.state[address_field].last_name} onChange={this.bindState(address_field + '.last_name')} />
                            {this.renderAddressErrors(address_field, 'last_name')}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-phone"} className="control-label">Phone</label>
                            <input id={address_field + "-phone"} type="text" className="form-control" placeholder="Phone" value={this.state[address_field].phone} onChange={this.bindState(address_field + '.phone')} />
                            {this.renderAddressErrors(address_field, 'phone')}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-email"} className="control-label">Email Address</label>
                            <input id={address_field + "-email"} type="text" className="form-control" placeholder="Email Address" value={this.state[address_field].email} onChange={this.bindState(address_field + '.email')} />
                            {this.renderAddressErrors(address_field, 'email')}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-country"} className="control-label">Country</label>
                            <select id={address_field + "-country"} className="form-control" value={country} onChange={this.bindState(address_field + '.country', v=> { this.state[address_field].subdivision = ''; return v;}, this.recalculateOrder)}>
                                <option key="_" value=""></option>
                                { countries.map(c => <option key={c.code} value={c.code}>{c.name}</option>) }
                            </select>
                            {this.renderAddressErrors(address_field, 'country')}
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor={address_field + "-street1"} className="control-label">Address</label>
                    <input id={address_field + "-street1"} type="text" className="form-control" placeholder="Street Address" value={this.state[address_field].street1} onChange={this.bindState(address_field + '.street1')} />
                    {this.renderAddressErrors(address_field, 'street1')}
                </div>
                <div className="form-group">
                    <input id={address_field + "-street2"} type="text" className="form-control" placeholder="Apartment, suite, unit, etc. (optional) " value={this.state[address_field].street2} onChange={this.bindState(address_field + '.street2')} />
                    {this.renderAddressErrors(address_field, 'street2')}
                </div>
                <div className="form-group">
                    <label htmlFor={address_field + "-city"} className="control-label">City</label>
                    <input id={address_field + "-city"} type="text" className="form-control" placeholder="City" value={this.state[address_field].city} onChange={this.bindState(address_field + '.city')} />
                    {this.renderAddressErrors(address_field, 'city')}
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-subdivision"} className="control-label">State / Province</label>
                            { /^(?:BR|CA|IT|MX|US)/.test(country || '') ?
                                <select id={address_field + "-subdivision"} className="form-control" value={this.state[address_field].subdivision} onChange={this.bindState(address_field + '.subdivision')}>
                                    <option key="_" value=""></option>
                                    { _states[country].map(ln => <option key={country + '-' + ln[0]} value={ln[0]}>{ln[1]}</option>) }
                                </select>
                                    :
                                    <input id={address_field + "-subdivision"} type="text" className="form-control" placeholder="State / Province" value={this.state[address_field].subdivision} onChange={this.bindState(address_field + '.subdivision')} />
                            }
                            {this.renderAddressErrors(address_field, 'subdivision')}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label htmlFor={address_field + "-postal_code"} className="control-label">Postcode / ZIP</label>
                            <input id={address_field + "-postal_code"} type="text" className="form-control" placeholder="Postcode / ZIP" value={this.state[address_field].postal_code} onChange={this.bindState(address_field + '.postal_code')} />
                            {this.renderAddressErrors(address_field, 'postal_code')}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render () {
        var address = this.state.address;

        return (
            <form action="" method="POST" onSubmit={this.onSubmit}>
                <div className="row">
                    <div className="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
                        <h2>Edit Address</h2>
                        <hr />
                        {renderErrors(this.state.errors && this.state.errors._overall_)}
                        <h3>{ address.is_default_billing ? 'Billing' : address.is_default_shipping ? 'Shipping' : ''} Address</h3>
                        { this.renderAddressFields() }
                        <div className="form-group">
                            <button type="submit" className="btn btn-primary">Save</button>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

